(function () {
    'use strict';

    angular
        .module('app')
        .controller('GuideHostsController', GuideHostsController);

        GuideHostsController.$inject = ['$rootScope' , 'localization'];

    function GuideHostsController($rootScope, localization) {
        var GuideHostsCtrl = this;
        GuideHostsCtrl.$onInit = init;


        function init() {
            $rootScope.header_inverted = true;
            localization.getLocation().then(function(response) {
                GuideHostsCtrl.location = response;
            });
        }

    }
})();